export default __webpack_public_path__ + "static/media/deliver.20db7209.svg";